import { Trans } from '@lingui/react/macro';
import EmptyStateChat from './EmptyStateChat';
import EmptyStateDone from './EmptyStateDone';
import EmptyStateFile from './EmptyStateFile';
import EmptyStateInbox from './EmptyStateInbox';
import EmptyStatePictures from './EmptyStatePictures';
import EmptyStateSearch from './EmptyStateSearch';
import EmptyStateSleep from './EmptyStateSleep';
import EmptyStateDefault from './EmptyStateDefault';
import EmptyStateError from './EmptyStateError';
import { useTheme } from '@emotion/react';
import { FC } from 'react';
import classnames from 'src/util/classnames';

type IconName = 'chat' | 'check' | 'error' | 'file' | 'inbox' | 'pictures' | 'search' | 'sleep';

const ICON_MAP: Record<IconName, FC<{ width?: number | string; height?: number | string; color?: string }>> = {
  chat: EmptyStateChat,
  check: EmptyStateDone,
  error: EmptyStateError,
  file: EmptyStateFile,
  inbox: EmptyStateInbox,
  pictures: EmptyStatePictures,
  search: EmptyStateSearch,
  sleep: EmptyStateSleep,
};

interface EmptyStateProps {
  size?: number;
  message: string;
  icon?: string;
  color?: string;
  filtersApplied?: boolean;
  clearFilters?: (() => void) | null;
  className?: string;
}

const EmptyState: FC<EmptyStateProps> = ({ size = 200, message, icon, color, filtersApplied = false, clearFilters, className = '' }) => {
  const theme = useTheme();
  let Icon = icon && icon in ICON_MAP ? ICON_MAP[icon as IconName] : EmptyStateDefault;

  const showFilterBar = filtersApplied && typeof clearFilters === 'function';
  if (showFilterBar) Icon = ICON_MAP.search;

  return (
    <div
      className={classnames('flex flex-col items-center text-center h-full w-full', className)}
      style={{ padding: '24px 16px', justifyContent: 'center', position: 'relative' }}
    >
      <Icon width={size} height={size} color={theme.primaryMain} />
      <div style={{ position: 'relative', top: -15 }}>
        <p className="text-primary font-bold mb-0" style={{ maxWidth: '320px' }}>
          {message}
        </p>
        {showFilterBar && (
          <div className="flex items-center mt-2" style={{ gap: '8px' }}>
            <span className="text-muted small">
              <Trans>Filters are applied</Trans>
            </span>
            <button className="btn btn-sm btn-outline-secondary" type="button" onClick={clearFilters!}>
              <Trans>Clear filters</Trans>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
